export default function Solutions() {
  const solutions = [
    {
      name: 'FRIDAY',
      tagline: 'Global Matching Platform',
      description: 'Two-sided marketplace connecting individuals with verified local experts. 1:1 consultations, booking system, secure payment, 13-country network.',
      features: [
        { icon: 'ri-verified-badge-line', label: 'Identity verification' },
        { icon: 'ri-video-chat-line', label: 'Video consultation' },
        { icon: 'ri-bank-card-line', label: 'Stripe Connect' },
        { icon: 'ri-global-line', label: 'Partner network' }
      ],
      badge: 'Launching 2025',
      badgeColor: 'from-blue-500 to-blue-600',
      image: 'https://public.readdy.ai/ai/img_res/4a60eff1ac10269a224cb055a823c156.jpg',
      iconBadge: 'ri-global-line',
      iconBadgeSecondary: 'ri-team-line'
    },
    {
      name: 'FRIDAY AGENT',
      tagline: 'Immigration Practice Automation',
      description: 'AI workflow automation for immigration lawyers. Automate consultation notes, document review, application drafting—reducing admin time 70%.',
      features: [
        { icon: 'ri-mic-line', label: 'AI transcription' },
        { icon: 'ri-task-line', label: 'Automated review' },
        { icon: 'ri-file-text-line', label: 'AI drafting' },
        { icon: 'ri-dashboard-line', label: 'Data grid dashboard' }
      ],
      badge: 'Q2 2026 Launch',
      badgeColor: 'from-purple-500 to-indigo-600',
      image: 'https://readdy.ai/api/search-image?query=desktop%20computer%20mockup%20showing%20modern%20data%20grid%20dashboard%20with%20kanban%20board%20and%20document%20preview%20panels%2C%20split-view%20interface%20with%20task%20management%20and%20file%20system%2C%20clean%20purple%20and%20white%20UI%20design%2C%20professional%20business%20software%20screenshot%20with%20organized%20layout%20and%20data%20tables&width=500&height=400&seq=agent-dashboard-mockup&orientation=landscape',
      iconBadge: 'ri-file-text-line',
      iconBadgeSecondary: 'ri-sparkling-line'
    },
    {
      name: 'ENTERPRISE CRM',
      tagline: 'Custom Solutions for International Expansion',
      description: 'Tailored CRM for companies entering foreign markets. Partner management, multi-language support, local payment integration.',
      features: [
        { icon: 'ri-translate-2', label: 'Multi-language/currency' },
        { icon: 'ri-team-line', label: 'Unified management' },
        { icon: 'ri-flow-chart', label: 'Workflow automation' },
        { icon: 'ri-secure-payment-line', label: 'Global payment' }
      ],
      badge: 'Custom Development',
      badgeColor: 'from-slate-500 to-slate-600',
      image: 'https://readdy.ai/api/search-image?query=isometric%203D%20illustration%20of%20office%20building%20with%20gear%20mechanism%20and%20global%20network%20connections%2C%20modern%20business%20concept%20showing%20international%20expansion%20and%20enterprise%20systems%2C%20gray%20and%20teal%20color%20scheme%2C%20clean%20geometric%20design%20with%20world%20map%20elements%20and%20connection%20lines%20representing%20CRM%20infrastructure&width=500&height=400&seq=enterprise-crm-illustration&orientation=landscape',
      iconBadge: 'ri-building-line',
      iconBadgeSecondary: 'ri-settings-3-line'
    }
  ];

  return (
    <section id="solutions" className="scroll-animate py-36 bg-white">
      <div className="max-w-7xl mx-auto px-20">
        <div className="text-center mb-16">
          <div className="text-xs font-semibold text-blue-600 tracking-[2px] uppercase mb-5">
            WHAT WE BUILD
          </div>
          <h2 className="text-5xl font-bold text-slate-900">
            Our Solutions
          </h2>
        </div>
        
        <div className="grid grid-cols-3 gap-10">
          {solutions.map((solution, index) => (
            <div 
              key={index}
              className="group bg-white rounded-2xl shadow-md hover:shadow-2xl transition-all duration-500 overflow-hidden cursor-pointer"
            >
              {/* Top: Hero image with icon badge */}
              <div className="relative h-64 overflow-hidden bg-slate-100">
                <img 
                  src={solution.image}
                  alt={solution.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                {/* Icon badge floating above */}
                <div className="absolute top-4 right-4 w-16 h-16 bg-white rounded-full shadow-lg flex items-center justify-center">
                  <div className="relative">
                    <i className={`${solution.iconBadge} text-2xl text-slate-700`}></i>
                    <i className={`${solution.iconBadgeSecondary} text-sm text-blue-600 absolute -bottom-1 -right-1`}></i>
                  </div>
                </div>
              </div>
              
              <div className="p-8">
                <h3 className="text-2xl font-bold text-slate-900 mb-2">
                  {solution.name}
                </h3>
                <p className="text-sm font-medium text-slate-500 mb-5">
                  {solution.tagline}
                </p>
                <p className="text-base text-slate-600 leading-relaxed mb-6">
                  {solution.description}
                </p>
                
                {/* Feature icons with labels */}
                <div className="grid grid-cols-2 gap-4 mb-6">
                  {solution.features.map((feature, idx) => (
                    <div key={idx} className="flex items-center gap-2">
                      <div className="w-8 h-8 flex items-center justify-center bg-blue-50 rounded-lg">
                        <i className={`${feature.icon} text-blue-600 text-lg`}></i>
                      </div>
                      <span className="text-sm text-slate-600">{feature.label}</span>
                    </div>
                  ))}
                </div>
                
                {/* Badge */}
                <div className="flex justify-center">
                  <span className={`inline-block bg-gradient-to-r ${solution.badgeColor} text-white text-xs font-medium px-5 py-2 rounded-full shadow-md`}>
                    {solution.badge}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
